export const InstitutionStandardization = [
  '100% Nestlé',
  '100% Concorrentes',
  '100% Mista'
];
